/// <reference path="./typings/globals.d.ts" />
/// <reference path="./typings/style.scss.d.ts" />

import * as $ from 'jQuery';
import 'bootstrap';
import 'popper.js';
import 'owl.carousel';
import 'jquery.appear';
import "form-data";

import { animate } from './lib/animate';
import { carousel } from './lib/carousel';
import { headerEvents } from './lib/header';
import { ratioBlock } from './lib/ratio-block';
import { CaseStudies } from './lib/caseStudies';
import { HomepageEvents } from "./lib/homepageEvents";
import { accordionEvents } from "./lib/accordionEvents";
import { ContactForm } from "./lib/contactForm";
import { blogBackToTop } from "./lib/blogBackToTop";



import '../scss/style.scss';

animate();
carousel();
headerEvents();
ratioBlock();
CaseStudies();
HomepageEvents();
accordionEvents();
ContactForm();
blogBackToTop();